var styles = [".modal-header[_ngcontent-%COMP%]{-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}.modal-backdrop[_ngcontent-%COMP%]{background-color:rgba(49,49,49,.5)}"];
export { styles as styles };
